import Logo from "../styles/images/logo.svg";
import DriverQRImage from "../styles/images/Apni_Gaadi_Business.svg";
import CustomerQRImage from "../styles/images/Apni_Gaadi_Customer_App.svg";
import PlayStoreIcon from "../styles/images/play-store.svg";
import { Link } from "react-router-dom";
export default function Footer() {
  return (
    <div className="footer-container" id="download">
      <div className="footer-content">
        <div className="footer-section-logo">
          <img src={Logo} alt="Apni Gaadi Logo" height="80" />
        </div>
        <div className="footer-section-heading">Get the Ye Apni Gaadi App</div>
        <div className="footer-section-description">
          Book rides, track services, and manage your journeys — all from one
          place.
        </div>
        <div className="footer-section-qr">
          <div className="qr-code-image">
            <div className="download-head">Grow with the Business App</div>
            <div className="download-subhead">
              Manage bookings and operations seamlessly—download from Google
              Play.
            </div>
            <div className="download-cta">
              <Link
                to={
                  "https://play.google.com/store/apps/details?id=com.apisod.apnigaadi.business"
                }
                target="_blank"
              >
                <img
                  className="play-store-img"
                  src={PlayStoreIcon}
                  alt="PlayStoreIcon"
                />
              </Link>
              <p>OR</p>
              <img className="qr-code-img" src={DriverQRImage} alt="QR Code" />
              <p>Scan Us</p>
            </div>
          </div>
          <div className="qr-code-image">
            <div className="download-head">Book with the Customer App</div>
            <div className="download-subhead">
              Find and book trusted services in seconds—available on Google
              Play.
            </div>
            <div className="download-cta">
              <Link
                to={
                  "https://play.google.com/store/apps/details?id=com.apisod.apnigaadi"
                }
                target="_blank"
              >
                <img
                  className="play-store-img"
                  src={PlayStoreIcon}
                  alt="PlayStoreIcon"
                />
              </Link>
              <p>OR</p>
              <img
                className="qr-code-img"
                src={CustomerQRImage}
                alt="QR Code"
              />
              <p>Scan Us</p>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-bottom-bar">
        <div className="container">
          <div className="footer-bottom-content">
            <div className="copywrite">
              © 2026 Apni Gaadi. All rights reserved.
            </div>
            <div className="footer-links">
              <Link to="/privacy-policy" className="footer-link">
                Privacy Policy
              </Link>
              <Link to="/terms-and-conditions" className="footer-link">
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
